import React, { useState, useEffect } from "react";
import { getURLSearchParam } from '../../lib/iprs-react-library/src/index';
const BookingSummary = ({ api }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [token, setToken] = useState('');
  const [facilityID, setFacilityID] = useState('');
  const [facilityName, setFacilityName] = useState('');
  const [Address, setAddress] = useState('');
  const [selectedSlot, setSelectedSlot] = useState(null);
   const [startTime, setStartTime] = useState('');
      const [endTime, setEndTime] = useState('');
      const [appointmentDate, setAppointmentDate] = useState('');

  useEffect(() => {
    const tokenParam = getURLSearchParam('Token');
    const facilityIDParam = getURLSearchParam('FacilityID');
    setToken(tokenParam);
    setFacilityID(facilityIDParam);

    const urlParamFacilityName = getURLSearchParam('FacilityName');
    setFacilityName(decodeURIComponent(urlParamFacilityName));

    const urlParamAddress = getURLSearchParam('Address');
    let fullAddress = "";
    try {
      const parsedAddress = JSON.parse(decodeURIComponent(urlParamAddress));
      if (typeof parsedAddress === "object" && parsedAddress !== null) {
        fullAddress = [
          parsedAddress.Address1,
          parsedAddress.Address2,
          parsedAddress.Address3,
          parsedAddress.Postcode
        ].filter(Boolean).join(", ");
      } else {
        fullAddress = parsedAddress;
      }
    } catch (e) {
      console.error("Failed to parse address:", e);
      fullAddress = decodeURIComponent(urlParamAddress);
    }
    setAddress(fullAddress);
    const urlParamSlot = getURLSearchParam("selectedSlot");
if (urlParamSlot) {
  try {
    setSelectedSlot(JSON.parse(decodeURIComponent(urlParamSlot)));
  } catch (e) {
    console.error("Failed to parse selectedSlot:", e);
    setSelectedSlot(null);
  }
} else {
  setSelectedSlot(null);
}
 const urlParamSelectedSlot = getURLSearchParam('selectedSlot'); if (urlParamSelectedSlot) {
            try {
                const parsedSlot = JSON.parse(decodeURIComponent(urlParamSelectedSlot));
                setSelectedSlot(parsedSlot);
                // Convert UTC times to UK time and format to 12-hour AM/PM
                if (parsedSlot.startDateTime) {
                    const startUK = toUKTime(parsedSlot.startDateTime);
                    const startFormatted = new Intl.DateTimeFormat("en-GB", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                        timeZone: "Europe/London"
                    }).format(new Date(parsedSlot.startDateTime));
                    setStartTime(startFormatted);
                }

                if (parsedSlot.endDateTime) {
                    const endUK = toUKTime(parsedSlot.endDateTime);
                    const endFormatted = new Intl.DateTimeFormat("en-GB", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                        timeZone: "Europe/London"
                    }).format(new Date(parsedSlot.endDateTime));
                    setEndTime(endFormatted);
                }

                if (parsedSlot.startDateTime) {
                    const ukDate = new Intl.DateTimeFormat("en-GB", {
                        timeZone: "Europe/London",
                        year: "numeric",
                        month: "long",
                        day: "2-digit"
                    }).format(new Date(parsedSlot.startDateTime));
                    setAppointmentDate(ukDate);
                }
            } catch (e) {
                console.error("Failed to parse selectedSlot from URL:", e);
                setSelectedSlot(null);
            }
        } else {
            setSelectedSlot(null);
        }
  }, []);

  function redirectBackToReferral() {

    let referralUrl = '../Referral' + '?Token=' + api.getToken();
    const postcodeSearch = getURLSearchParam("postcode");
    if (typeof postcodeSearch === 'string' && postcodeSearch !== '') {
      referralUrl += "&postcode=" + encodeURIComponent(postcodeSearch);
    }

    window.location.replace(referralUrl);
  }
  
    const toUKTime = (dateString) => {
        return new Intl.DateTimeFormat("en-GB", {
            timeZone: "Europe/London",
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        }).format(new Date(dateString));
    };
  const confirmBooking = () => {
    setIsLoading(true);
    setErrorMsg("");

    api.transact("MakeReferral", { Token: token, FacilityID: facilityID,SelectedSlot: selectedSlot })
      .then(r => {
        const urlForFeedBack = `../feedback/?Token=${token}&FacilityID=${facilityID}&SelectedSlot=${encodeURIComponent(JSON.stringify(selectedSlot ?? null))}`;
        window.location.replace(urlForFeedBack);
      })
      .catch(err => {
        console.error("MakeReferral error:", err.message);
        setErrorMsg(err.message);
        setIsLoading(false);
      });
  };

  return (

    <div className="booking-container">
      <div className="back-button-container">
        <button className="back-button" onClick={redirectBackToReferral}>
          &larr; Back To Search
        </button>
      </div>

      <div className="booking-panel">
        <h2 className="booking-heading">Booking Summary</h2>

        <div className="booking-info">
          <div className="booking-label">Clinic:</div>
          <div className="booking-value">{facilityName}</div>
        </div>

        <div className="booking-info">
          <div className="booking-label">Address:</div>
          <div className="booking-value">{Address}</div>
        </div>
        
                 {selectedSlot && (
                        <>
                            <div className="booking-info">
                                <span className="booking-label">Date:</span>
                                <span className="booking-value">{appointmentDate}</span>
                            </div>
                            <div className="booking-info">
                                <span className="booking-label">Time:</span>
                                <span className="booking-value">{startTime} - {endTime}</span>
                            </div>
                        </>
                    )}

        {errorMsg && <p className="booking-error">{errorMsg}</p>}

        <button
          className="booking-button"
          onClick={confirmBooking}
          disabled={isLoading}
        >
          {isLoading ? "Confirming..." : "Confirm Booking"}
        </button>
      </div>
    </div>
  );
};

export default BookingSummary;
